import { useEffect, useState } from "react";
import { Checkbox } from "primereact/checkbox";
import { DataTable } from "primereact/datatable";
import { Column } from "jspdf-autotable";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";

export const Funcion = ({ usuario, rol, menu, toast, generic, permss }) => {
    const [sasignar, setSasignar] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(true);
    const [registros, setRegistros] = useState(null);
    const [lazyParams, setLazyParams] = useState(generic.paramLazy({ nombre: 'contains' }, null));
    const monitoreoService = new MonitoreoService();

    const onPage = (event) => {
        setLazyParams(event);
    }

    const onSort = (event) => {
        setLazyParams(event);
    }

    const onFilter = (event) => {
        setLazyParams(event);
    }

    useEffect(() => {
        loadLazyData();
    }, [lazyParams]);

    const loadLazyData = () => {
        setLoading(true);
        let _lazyParams = lazyParams;
        _lazyParams.usuario = usuario;
        _lazyParams.rol = rol;
        _lazyParams.menu = menu;
        monitoreoService.listado('admin/funcion-menu/funciones', { lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setRegistros(res.data.registros);
            setLoading(false);
            let inicial = [];
            res.data.registros.forEach(item => {
                if (item.fecha != null) {
                    inicial.push(item.id);
                }
            });
            setSasignar(inicial);
        });
    }

    const asignar = (e) => {
        let _seleccionados = [...sasignar];
        if (e.checked)
            _seleccionados.push(e.value);
        else
            _seleccionados.splice(_seleccionados.indexOf(e.value), 1);

        monitoreoService.editar({ id: e.value, usuario: usuario, rol: rol, agregar: e.checked }, 'admin/funcion-menu/asignar').then(res => {
            toast.current.show({ severity: 'success', summary: 'Exitoso', detail: res?.message, life: 3000 });
            loadLazyData();
        }).catch(error => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error, life: 3000 });
        });

        setSasignar(_seleccionados);
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                {(permss.crear || permss.actualizar) &&
                    <Checkbox value={rowData.id} checked={sasignar.indexOf(rowData.id) !== -1} onChange={asignar} />
                }
            </div>
        );
    };

    return (
        <DataTable value={registros} lazy className="datatable-responsive"
            filterDisplay="row" dataKey="id"
            paginator first={lazyParams.first} rows={10} totalRecords={totalRecords} onPage={onPage}
            onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
            onFilter={onFilter} filters={lazyParams.filters} loading={loading}>

            <Column field="nombre" header='Funcionalidad' sortable showFilterMenu={false} filterField='nombre' filter filterPlaceholder='Filtrar por funcionalidad' />
            <Column field="codigo" header='Código' showFilterMenu={false} />
            <Column field="fecha" sortable header='Fecha de asignación' />
            <Column header='Asignar / Quitar' body={actionBodyTemplate}></Column>

        </DataTable>
    )
}
